import { useEffect } from "react";

const SITE_URL = "https://www.ashlarbuildchem.com";
const DEFAULT_IMAGE = "https://www.ashlarbuildchem.com/logo.png";
const SITE_NAME = "Ashlar Buildchem";

export const SEO_CONFIG = {
  home: {
    title: "Construction Chemical Manufacturer in Jaipur | Ashlar",
    description:
      "Ashlar Buildchem is a construction chemical manufacturer in Jaipur offering tile adhesives, tile grouts, AAC adhesives, admixtures and flooring solutions.",
    keywords:
      "Construction Chemical Manufacturer in Jaipur, Construction Chemicals in Jaipur, Construction Chemical Company in Jaipur, Construction Chemical Supplier in Jaipur, Building Construction Chemicals in Jaipur, Tile Adhesive Manufacturer in Jaipur",
    canonical: `${SITE_URL}/`,
  },
  about: {
    title: "About Ashlar Buildchem | Construction Chemical Manufacturer",
    description:
      "Learn about Ashlar Buildchem, a construction chemical manufacturer in Jaipur offering tile adhesives, grouts, AAC adhesives and building solutions.",
    keywords:
      "Construction Chemical Manufacturer in Jaipur, Construction Chemical Company in Jaipur, Construction Chemicals Manufacturer in Jaipur, Building Construction Chemicals in Jaipur, Tile Adhesive Manufacturer in Jaipur, Tile Grout Manufacturer in Jaipur, AAC Block Adhesive Manufacturer in Jaipur, Construction Chemical Supplier in Jaipur, Building Material Manufacturer in Jaipur",
    canonical: `${SITE_URL}/about`,
  },
  products: {
    title: "Construction Chemical Products in Jaipur | Ashlar",
    description:
      "Explore Ashlar construction chemicals in Jaipur including tile adhesives, tile grouts, epoxy grout, AAC adhesives, admixtures and flooring solutions.",
    keywords:
      "Construction Chemical Products in Jaipur, Construction Chemicals in Jaipur, Tile Adhesive in Jaipur, Tile Grout in Jaipur, Epoxy Grout in Jaipur, AAC Block Adhesive in Jaipur, Construction Admixtures in Jaipur, Ready Mix Plaster in Jaipur, Floor Hardener in Jaipur, Building Construction Chemicals in Jaipur",
    canonical: `${SITE_URL}/products`,
  },
  categories: {
    "tile-adhesives": {
      title: "Tile Adhesive Manufacturer in Jaipur | Ashlar",
      description:
        "Ashlar offers tile adhesives in Jaipur for ceramic, vitrified, natural stone and large-format tiles for suitable internal and external applications.",
      keywords:
        "Tile Adhesive in Jaipur, Tile Adhesive Manufacturer in Jaipur, Tile Adhesive Supplier in Jaipur, Tile Adhesive Price in Jaipur, Tile Fixing Adhesive in Jaipur, Ceramic Tile Adhesive in Jaipur, Vitrified Tile Adhesive in Jaipur, Floor Tile Adhesive in Jaipur, Wall Tile Adhesive in Jaipur",
      canonical: `${SITE_URL}/products?cat=tile-adhesives`,
    },
    grouts: {
      title: "Tile Grout & Epoxy Grout Manufacturer in Jaipur",
      description:
        "Explore Ashlar tile grout and epoxy grout solutions in Jaipur for suitable floor and wall applications with reliable performance and finish.",
      keywords:
        "Tile Grout in Jaipur, Tile Grout Manufacturer in Jaipur, Tile Grout Supplier in Jaipur, Epoxy Grout in Jaipur, Epoxy Tile Grout in Jaipur, Cementitious Grout in Jaipur, Floor Tile Grout in Jaipur, Wall Tile Grout in Jaipur, Tile Joint Grout in Jaipur, Grout for Tiles in Jaipur",
      canonical: `${SITE_URL}/products?cat=grouts`,
    },
    admixtures: {
      title: "Construction Admixtures Manufacturer in Jaipur | Ashlar",
      description:
        "Explore Ashlar construction admixtures and additives in Jaipur for suitable concrete and building applications.",
      keywords:
        "Construction Admixtures in Jaipur, Construction Admixture Manufacturer in Jaipur, Construction Admixture Supplier in Jaipur, Concrete Admixtures in Jaipur, Construction Additives in Jaipur, Concrete Additives in Jaipur, Building Admixtures in Jaipur, Construction Chemical Additives in Jaipur",
      canonical: `${SITE_URL}/products?cat=admixtures`,
    },
    "block-adhesive": {
      title: "AAC Block Adhesive Manufacturer in Jaipur | Ashlar",
      description:
        "Ashlar offers AAC block adhesive and thin-bed adhesive solutions in Jaipur for suitable AAC block and brick masonry applications.",
      keywords:
        "AAC Block Adhesive in Jaipur, AAC Block Adhesive Manufacturer in Jaipur, AAC Block Adhesive Supplier in Jaipur, AAC Block Jointing Adhesive in Jaipur, Block Jointing Adhesive in Jaipur, AAC Block Adhesive Price in Jaipur, Thin Bed Adhesive in Jaipur, AAC Block Mortar in Jaipur, Block Adhesive in Jaipur",
      canonical: `${SITE_URL}/products?cat=block-adhesive`,
    },
    "surface-solutions": {
      title: "Ready Mix Plaster Manufacturer in Jaipur | Ashlar",
      description:
        "Ashlar offers ready mix plaster solutions in Jaipur for suitable wall and plastering applications with consistent site application.",
      keywords:
        "Ready Mix Plaster in Jaipur, Ready Mix Plaster Manufacturer in Jaipur, Ready Mix Plaster Supplier in Jaipur, Premixed Plaster in Jaipur, Ready Mix Wall Plaster in Jaipur, Wall Plaster in Jaipur, Cement Plaster in Jaipur, Ready Made Plaster in Jaipur, Plastering Material in Jaipur",
      canonical: `${SITE_URL}/products?cat=surface-solutions`,
    },
  },
  calculators: {
    title: "Tile Adhesive & Grout Calculators | Ashlar",
    description:
      "Use Ashlar calculators to estimate tile adhesive and grout requirements based on tile size, joint width and application conditions.",
    keywords:
      "Tile Adhesive Calculator, Tile Adhesive Coverage Calculator, Tile Adhesive Quantity Calculator, Tile Adhesive Consumption Calculator, Grout Calculator, Grout Coverage Calculator, Tile Grout Quantity Calculator, Tile Adhesive Required Per Sq Ft",
    canonical: `${SITE_URL}/calculators`,
  },
  calculatorAdhesive: {
    title: "Tile Adhesive Coverage Calculator | Ashlar",
    description:
      "Calculate estimated tile adhesive quantity using tile size, substrate and application details with Ashlar's coverage calculator.",
    keywords:
      "Tile Adhesive Coverage Calculator, Tile Adhesive Calculator, Tile Adhesive Quantity Calculator, Tile Adhesive Consumption, Tile Adhesive Coverage, Tile Adhesive Required Per Sq Ft, Tile Adhesive Calculation",
    canonical: `${SITE_URL}/calculators?tool=adhesive`,
  },
  calculatorGrout: {
    title: "Grout Coverage Calculator | Ashlar Buildchem",
    description:
      "Calculate estimated grout quantity using tile dimensions and joint width with Ashlar's grout coverage calculator.",
    keywords:
      "Grout Calculator, Grout Coverage Calculator, Tile Grout Calculator, Grout Quantity Calculator, Tile Grout Quantity Calculator, Grout Consumption Calculator, Grout Required for Tiles",
    canonical: `${SITE_URL}/calculators?tool=grout`,
  },
  blog: {
    title: "Construction Chemical & Tile Adhesive Insights | Ashlar",
    description:
      "Explore insights on tile adhesives, grouts, AAC adhesives, construction chemicals, applications and building solutions in Jaipur.",
    keywords:
      "Construction Chemical Blog Jaipur, Construction Chemicals Blog Jaipur, Tile Adhesive Blog Jaipur, Tile Adhesive Guide, Tile Adhesive Tips, Construction Chemical Guide, Tile Grout Guide, AAC Block Adhesive Guide, Construction Tips Jaipur, Building Material Guide Jaipur",
    canonical: `${SITE_URL}/blog`,
  },
  contact: {
    title: "Contact Ashlar Buildchem | Construction Chemicals",
    description:
      "Contact Ashlar Buildchem in Jaipur for construction chemicals, tile adhesives, grouts, AAC adhesives, technical guidance and quotations.",
    keywords:
      "Construction Chemical Manufacturer in Jaipur, Construction Chemical Supplier in Jaipur, Tile Adhesive Manufacturer in Jaipur, Tile Adhesive Supplier in Jaipur, Construction Chemical Company in Jaipur, Tile Grout Supplier in Jaipur, AAC Block Adhesive Supplier in Jaipur, Construction Chemical Enquiry Jaipur",
    canonical: `${SITE_URL}/contact`,
  },
  groutVisualizer: {
    title: "Grout Visualiser for Tiles | Ashlar Buildchem",
    description:
      "Visualise different grout colours and finishes for your tiles with Ashlar Buildchem's Grout Visualiser before selecting your grout.",
    keywords:
      "Grout Visualiser, Grout Visualizer, Tile Grout Visualiser, Tile Grout Visualizer, Grout Colour Visualiser, Grout Color Visualizer, Tile Grout Colour Tool, Tile Grout Color Tool, Grout Colour Tool, Grout Selection Tool",
    canonical: `${SITE_URL}/grout-visualizer`,
  },
  careers: {
    title: "Careers at Ashlar Buildchem | Urgent Hiring - Field Sales Executives",
    description:
      "Urgent hiring for Field Sales Executives at Ashlar Buildchem in Jaipur, Sikar, and Dausa (₹20,000–₹30,000/mo + petrol reimbursement). Explore job openings in technical sales, R&D, and manufacturing.",
    keywords:
      "Field Sales Executive Jobs Jaipur, Field Sales Executive Sikar, Field Sales Executive Dausa, Construction Chemical Sales Jobs, Building Materials Sales Jobs Rajasthan, Tile Adhesive Sales Executive, Ashlar Buildchem Careers",
    canonical: `${SITE_URL}/careers`,
  },
};

const updateMetaTag = (attribute, nameOrProperty, content) => {
  if (!content) return;
  let element = document.querySelector(`meta[${attribute}="${nameOrProperty}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, nameOrProperty);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const updateLinkTag = (rel, href) => {
  if (!href) return;
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
};

const updateJsonLd = (schema) => {
  const existingScript = document.getElementById("structured-data-jsonld");
  if (existingScript) {
    existingScript.remove();
  }
  if (schema) {
    const script = document.createElement("script");
    script.id = "structured-data-jsonld";
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }
};

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  ogType = "website",
  ogImage = DEFAULT_IMAGE,
  schema,
}) {
  useEffect(() => {
    // 1. Document Title
    if (title) {
      document.title = title;
    }

    // 2. Standard Meta Tags
    updateMetaTag("name", "description", description);
    updateMetaTag("name", "keywords", Array.isArray(keywords) ? keywords.join(", ") : keywords);
    updateMetaTag("name", "author", SITE_NAME);

    // 3. Canonical URL
    const canonicalUrl = canonical
      ? (canonical.startsWith("http") ? canonical : `${SITE_URL}${canonical}`)
      : `${SITE_URL}${window.location.pathname}${window.location.search}`;
    updateLinkTag("canonical", canonicalUrl);

    // 4. Open Graph Tags
    const fullImageUrl = ogImage?.startsWith("http")
      ? ogImage
      : `${SITE_URL}${ogImage?.startsWith("/") ? "" : "/"}${ogImage || "logo.png"}`;

    updateMetaTag("property", "og:title", title);
    updateMetaTag("property", "og:description", description);
    updateMetaTag("property", "og:url", canonicalUrl);
    updateMetaTag("property", "og:type", ogType);
    updateMetaTag("property", "og:image", fullImageUrl);
    updateMetaTag("property", "og:site_name", SITE_NAME);
    updateMetaTag("property", "og:locale", "en_IN");

    // 5. Twitter Card Tags
    updateMetaTag("name", "twitter:card", "summary_large_image");
    updateMetaTag("name", "twitter:url", canonicalUrl);
    updateMetaTag("name", "twitter:title", title);
    updateMetaTag("name", "twitter:description", description);
    updateMetaTag("name", "twitter:image", fullImageUrl);

    // 6. Structured JSON-LD
    updateJsonLd(schema);
  }, [title, description, keywords, canonical, ogType, ogImage, schema]);

  return null;
}
